import { Typography } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLButton } from "OLButton";
import { ReactComponent as FilePlus03Icon } from "components/Icons/file-plus-03.svg";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { useMessage } from "hooks/intl";
import { useNavigate } from "react-router-dom";
import { links } from "utilities/links";

const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    container: {
      display: "flex",
      width: "100%",
      height: "100%",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      marginTop: theme.spacing(-24),
    },
    btnWrapper: {
      marginTop: theme.spacing(12),
      display: "flex",
      gap: theme.spacing(12),
    },
    title: {
      marginBottom: theme.spacing(4),
      color: theme.primary800,
      fontSize: "24px",
      fontWeight: 500,
      lineHeight: "29px",
    },
    subTitle: {
      fontSize: "16px",
      color: theme.gray500,
      fontWeight: 400,
      lineHeight: "24px",
      maxWidth: "393px",
      textAlign: "center",
    },
    iconWrapper: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "50%",
      backgroundColor: theme.primary50,
      marginBottom: theme.spacing(8),
      width: "44px",
      height: "44px",
    },
    icon: {
      color: theme.primary500,
    },
  }),
);

export const EmptyTierSet = ({ tierSetId }: { tierSetId?: string }) => {
  const classes = useStyles();
  const { message } = useMessage();
  const navigate = useNavigate();

  return (
    <div className={classes.container}>
      <div className={classes.iconWrapper}>
        <FilePlus03Icon className={classes.icon} />
      </div>
      <Typography className={classes.title}>
        {message({ id: "addTiersToThisSet" })}
      </Typography>
      <Typography className={classes.subTitle}>
        {message({ id: "memberAreAddedAutomaticallyIfMeetAppliedConditions" })}
      </Typography>
      <div className={classes.btnWrapper}>
        <OLButton
          onClick={() => navigate(links.editTierSet(tierSetId))}
          variant="outlined"
        >
          {message({ id: "configuration" })}
        </OLButton>
        <OLButton
          onClick={() => navigate(links.tierSetAddTiers(tierSetId))}
          data-test-id="add-custom-tier-button"
          variant="contained"
        >
          {message({ id: "addTiers" })}
        </OLButton>
      </div>
    </div>
  );
};
